import classNames from 'classnames';
import React, { useMemo, useRef, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import useDashboardStore from 'src/dashboard/store/dashboard';
import { useNewJourneyStore } from 'src/dashboard/store/new-journey';
import { useUserOnboardingStore } from 'src/onboarding/store/user-onboarding.store';
import { useCurrentOrganization } from 'src/store/organization';
import { NewJourneyType } from '../../interfaces/journey/new-journey-type.enum';
import { CreateJourneyCard } from './card';
import { CreateJourneyTypes } from './types';
import { useBubbleStore } from 'src/onboarding/store/bubble.store';
import { EventBus } from 'src/common/EventBus';
import { CreateJourneyModal } from 'src/editor/content-creation/components/dashboard/create-journey-modal';
import { trackSegmentEvent } from 'src/utils/segment';

// extend it on create-slide-over usage (vertical)
/**
 * @deprecated
 */
export const CreateJourneyCards = ({
  containerClassName,
  fromSidebar,
}: {
  containerClassName?: string;
  fromSidebar: boolean;
}) => {
  const setOnboardingShow = useUserOnboardingStore((state) => state.setShow);
  const resetBubbleStore = useBubbleStore((state) => state.resetBubbleStore);

  const { currentOrganization } = useCurrentOrganization.getState();
  const history = useHistory();

  const addActionFirstJourneyCreated = useUserOnboardingStore((state) => state.addActionFirstJourneyCreated);
  const setIsCreatingJourney = useDashboardStore((state) => state.setIsCreatingJourney);
  const { createJourney } = useNewJourneyStore((state) => ({
    createJourney: state.createJourney,
  }));

  const createJourneyModalOpenRef = useRef<() => void>();
  const createJourneyModalCloseRef = useRef<() => void>();

  const onClickCreateNeueJourney = useCallback(() => {
    createJourneyModalOpenRef.current?.();
  }, []);

  const onClickMapping: Record<NewJourneyType, () => void> = useMemo(
    () => ({
      [NewJourneyType.SCRATCH]: () => {
        createJourney(history);
        setIsCreatingJourney(false);
      },
      [NewJourneyType.WIZARD]: () => {
        EventBus.emit('wizard:open');
        setOnboardingShow(false);
        resetBubbleStore();
      },
      [NewJourneyType.ORG_TEMPLATE]: () => {
        history.push(`/${currentOrganization.slug}/templates?type=${NewJourneyType.ORG_TEMPLATE}`);
      },
      [NewJourneyType.JOURNEY_TEMPLATE]: () => {
        history.push(`/${currentOrganization.slug}/templates?type=${NewJourneyType.JOURNEY_TEMPLATE}`);
      },
      [NewJourneyType.NEUE_SCRATCH]: () => {
        onClickCreateNeueJourney?.();
      },
    }),
    [
      createJourney,
      history,
      setIsCreatingJourney,
      setOnboardingShow,
      resetBubbleStore,
      currentOrganization.slug,
      onClickCreateNeueJourney,
    ]
  );

  const onCreateJourneyCardClicked = (type: NewJourneyType) => {
    onClickMapping[type]();
    addActionFirstJourneyCreated();
    trackSegmentEvent('Create Journey Card Clicked', { card_type: type, from_sidebar: fromSidebar });
  };

  return (
    <>
      <div className={classNames('flex', containerClassName)}>
        {CreateJourneyTypes.map((wizardStack, index) => (
          <CreateJourneyCard
            key={`create-wizard-${index}`}
            {...wizardStack}
            onClick={() => onCreateJourneyCardClicked(wizardStack.type)}
          />
        ))}
        <CreateJourneyModal openRef={createJourneyModalOpenRef} closeRef={createJourneyModalCloseRef} />
      </div>
    </>
  );
};
